import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import * as moment from 'moment';
import { UserTeamModel } from '../../../../../../models/team-permissions.model';
import { ViewColumnComponent } from '../../../../../../view-column.component';
import { Observable, of, zip } from 'rxjs';
import { SubSink } from 'subsink2';
import { PermissionStates } from '../../../../permission-controller/root';
import { TeamPermSelectors } from '../../../../team-permissions-controller/selectors';
import { TeamPermStates } from '../../../../team-permissions-controller/states';

@Component({
  selector: 'app-team-permission-details',
  templateUrl: './team-permission-details.component.html',
  styleUrls: ['./team-permission-details.component.scss']
})
export class TeamPermissionDetailsComponent extends ViewColumnComponent {

  detailsForm: FormGroup;

  // ensure no subscriptions leak
  private subSink = new SubSink;

  // flag to indicate whether user can edit or not
  isReadOnly: Observable<boolean>;
  teamGuid: string;
  currentUser: UserTeamModel;

  team$ = this.store.select(TeamPermSelectors.selectTeam);
  currentUser$ = this.store.select(TeamPermSelectors.selectCurrentUser);

  constructor(
    private store: Store<PermissionStates>
  ) {
    super();
  }

  /**
   * Lifecycle method: Called when component is first initialised.
   */
  ngOnInit(): void {
    this.detailsForm = new FormGroup({
      name: new FormControl('', Validators.required),
      description: new FormControl(),
      code: new FormControl(),
      createdDate: new FormControl(),
      updatedDate: new FormControl(),
      createdBy: new FormControl(),
      updatedBy: new FormControl()
    })
    this.subSink.sink = this.currentUser$.subscribe(a => this.currentUser = a);
    // const form$ = this.store.select(TeamPermSelectors.selectDetailsForm);
    // this.subSink.sink = zip(form$, currentUser$)
    // .subscribe(([form, user]) => {
    //   if (form && user) {
    //     // set details form
    //     this.detailsForm = form;
    //     this.currentUser = user;
    //   }

    // })

    this.subSink.sink = this.team$
    .subscribe(team => {
      // set this team guid
      this.teamGuid = team.app_mst_grp_hdr.guid.toString();
      // set form values
      this.detailsForm.patchValue({
        name: team.app_mst_grp_hdr.name,
        description: team.app_mst_grp_hdr.description,

        // uneditable
        code: team.app_mst_grp_hdr.code,
        createdDate: team.app_mst_grp_hdr.created_date ? moment(team.app_mst_grp_hdr.created_date).format('YYYY-MM-DD HH:MM:ss') : "Data not available...",
        updatedDate: team.app_mst_grp_hdr.updated_date ? moment(team.app_mst_grp_hdr.updated_date).format('YYYY-MM-DD HH:MM:ss'): "Data not available...",
        createdBy: team.created_by_name ? team.created_by_name : "Data not available...",
        updatedBy: team.updated_by_name ? team.updated_by_name : "Data not available..."
      });
      // disable form accordingly
      this.isReadOnly = this.disableForm()
    })
  }

  /**
   * Return an observable that is of type boolean. True if the current user
   * is the admin or owner of the team or false otherwise. This is needed to
   * indicate whether the form should be disabled or enabled.
   *
   * @returns Observable<boolean> true if current user is owner or admin of the
   * team, false otherwise
   */
  disableForm() {
    const isInTeam = this.currentUser.link_subject_to_grps.map(x => x.app_grp_guid.toString()).includes(this.teamGuid);
    if (!isInTeam) {
      return of(true);
    } else {
      const rank = this.currentUser.link_subject_to_grps.filter(x => x.app_grp_guid.toString() == this.teamGuid)[0]['rank'];
      if (rank != 'OWNER' && rank != 'ADMIN') {
        return of(true);
      } else {
        return of(false);
      }
    }
  }

  /**
   * Lifecycle method: called when component is destroyed.
   */
  ngOnDestroy() {
    this.subSink.unsubscribe();
  }

}
